import React, { Component } from 'react';
import cases from '../../data/FocusData';

const Case = (CaseStudyProp: any) => 
    <div className="case-section" key={CaseStudyProp.id}>
      <div className="logo">
      {CaseStudyProp.img != null ? <img alt="FOCUS Website Screenshot" id="focushome" src={CaseStudyProp.img} /> : ''}
      </div>
        <div className="case-hd">{CaseStudyProp.section}</div>
        <div className="case-text">{CaseStudyProp.text}</div>
    </div>

class Focus extends Component {
render() { 
  return (
    <div className="case-container">
      {cases.map(Case)}
    </div>
    );
  }
}

export default Focus;